import { BasicResult } from "../../basic-result";

export class AuditSummaryResult extends BasicResult {
    public Response: string = "";
    public FileName: string = "";
    public FileID: string = "";
    public AssistantID: string = "";
    public Retryable: boolean = false;
    public RetryAfterSeconds?: number;
    public SupportReference: string = "";
    public FailureStage: string = "";
    constructor(values: Object = {}){
        super();
        Object.assign(this, values);     
    }
}
